import React from "react"

import Dropdown from './semantic-widgets/Dropdown.jsx'
import Datebox from "./Datebox.jsx"
import {Value} from "./Value.js"
import {MC} from './MC.js'
import {Widget} from "./Widget.jsx"


class TableFilterInput extends React.Component {

  buildFilterOperatorOptions(field) {
    let options = []
    let items = MC.asArray(MC.getFieldParamValue(field, 'filterOperatorItem*'))
    for (let item of items) {
      if (!item) break
      let key = item['@key']
      let title = item['@title'] !== undefined ? item['@title'] : key
      options.push({value: key, text: title, content: title})
    }
    return options
  }

  onChangeDateFilter = (field, fcolumn, value) => {
    if (value && value.isLuxonDateTime == true) {
      let withTimezone = MC.getFieldParamBooleanValue(field.param, '@outputTimezone')
      let basictype = MC.getFieldParamValue(fcolumn, '@filterBasicType') || field.basictype
      switch (basictype) {
        case 'dateTime': value = value.toFormat(withTimezone ? "yyyy-MM-dd'T'HH:mm:ss.SSSZZ" : "yyyy-MM-dd'T'HH:mm:ss.SSS"); break
        case 'time': value = value.toFormat(withTimezone ? "HH:mm:ssZZ" : "HH:mm:ss"); break
        default: value = value.toFormat(withTimezone ? "yyyy-MM-ddZZ" : "yyyy-MM-dd"); break
      }
      this.putValueByIndex(value)
      this.props.field.flow.runLazyUpdate(this.props.field)
    } else {
      this.putValueByIndex(value)
      if (value === '') {
        this.props.field.flow.runLazyUpdate(this.props.field)
      }
    }
  }

  onChangeFilter = (e) => {
    this.putValueByIndex(e.target.value)
    this.forceUpdate()
  }

  buildFilterOptions(field) {
    let options = []
    let items = MC.asArray(MC.getFieldParamValue(field, 'item*'))
    for (let item of items) {
      if (!item) break
      let key = item['@key']
      let title = item['@title'] !== undefined ? item['@title'] : key
      options.push({value: key, text: title, content: title})
    }
    return options
  }

  handleFilterKeyDown = (e) => {
    if (e.key == 'Enter') {
      e.stopPropagation()
      e.preventDefault()
      e.nativeEvent.stopImmediatePropagation()
      this.props.field.flow.runLazyUpdate(this.props.field)
    }
  }

  onChangeComboFilter = (e, combo) => {
    MC.putFieldParamValue(combo.column, '@filterValue', combo.value)
    this.props.field.flow.runLazyUpdate(this.props.field)
  }

  onChangeComboFilterOperator = (e, combo) => {
    MC.putFieldParamValue(combo.column, '@filterOperatorValue', combo.value[0])
    if (MC.getFieldParamValue(combo.column, '@filterValue')) {
      this.props.field.flow.runLazyUpdate(this.props.field)
    }
  }

  getValueByIndex() {
    let filValue = MC.getFieldParamValue(this.props.tableColumn, '@filterValue*') || []
    return filValue[this.props.valueIndex] || ''
  }

  putValueByIndex(value) {
    let fcolumn = this.props.tableColumn
    let filValue = MC.getFieldParamValue(fcolumn, '@filterValue*') || []
    if (this.props.valueIndex == 0) {
      filValue[0] = value
    } else {
      if (!filValue[0]) {
        filValue[0] = ''
      }  
      filValue[1] = value
    }
    MC.putFieldParamValue(fcolumn, '@filterValue', filValue)
  }

  render() {
    let fcolumn = this.props.tableColumn
    let colfield = this.props.field
    if (MC.getFieldParamBooleanValue(fcolumn, '@filterable') === false) {
      return <React.Fragment>&nbsp;</React.Fragment>
    } else {  
      let operator
      let operatorSelector = MC.getFieldParamBooleanValue(fcolumn, '@filterOperatorSelector')
      if (operatorSelector) {
        let options = this.buildFilterOperatorOptions(fcolumn)
        if (options.length == 0) {
          options = [{value: "=", text: "="}, {value: "!=", text: "!="}, {value: "<", text: "<"}, {value: ">", text: ">"}, {value: "<=", text: "<="},  {value: ">=", text: ">="}]
          if (!MC.getFieldParamValue(fcolumn, '@filterOperatorValue')) {
            MC.putFieldParamValue(fcolumn, '@filterOperatorValue', '=')
          }
        } else {
          if (!MC.getFieldParamValue(fcolumn, '@filterOperatorValue')) {
            MC.putFieldParamValue(fcolumn, '@filterOperatorValue', options[0].value)
          }
        }
        operator = <Dropdown className="compact selection" multiple={false} key={colfield.rbsid + 'o'} onChange={this.onChangeComboFilterOperator} value={[MC.getFieldParamValue(fcolumn, '@filterOperatorValue')]} options={options} closeOnChange={true} column={fcolumn} search={false}/>
      }
      const filType = MC.getFieldParamValue(fcolumn, '@filterType') || 'textbox'
      let filValue = filType == 'combobox' ? (MC.getFieldParamValue(fcolumn, '@filterValue*') || []) : this.getValueByIndex()
      let basicType = MC.getFieldParamValue(fcolumn, '@filterBasicType') || colfield.basictype
      let filterInput
      const rawPlaceholder = MC.asArray(MC.getFieldParamValue(fcolumn, '@filterPlaceholder*'))
      const placeholder = rawPlaceholder[this.props.valueIndex] ? rawPlaceholder[this.props.valueIndex] : rawPlaceholder[0]
      if (filType == 'datebox') {
        filterInput = <Datebox value={filValue} field={colfield} onChange={this.onChangeDateFilter.bind(this, colfield, fcolumn)} basicType={basicType} placeholder={placeholder}/>
      } else if (filType == 'combobox') {
        let options = this.buildFilterOptions(fcolumn)
        filterInput = <Dropdown className="fluid selection" multiple={true} key={colfield.rbsid} onChange={this.onChangeComboFilter} value={filValue} options={options} closeOnChange={true} column={fcolumn} search={true} placeholder={placeholder}/>
      } else {
        let type = ['integer', 'decimal'].indexOf(basicType) > -1 ? 'number' : 'text'
        let step = 'decimal' == basicType ? '0.01' : null
        filterInput = <input type={type} step={step} onChange={this.onChangeFilter} value={filValue} onKeyDown={this.handleFilterKeyDown} placeholder={placeholder}/>
      }
      if (operator) {
        return <div className="flex-row flex-no-wrap"><div>{operator}</div><div className="flex-grow">{filterInput}</div></div>
      } else {
        return filterInput
      }
    }
  }
}

function TableFilterCell(props) {

  if (Value.hasProperty(props.tableColumn, 'filterField')) {
    const filterFieldVal = Value.getProperty(props.tableColumn, 'filterField')
    if (!Value.isEmptyish(filterFieldVal)) {
      const field = MC.asArray(filterFieldVal)[0]
      if (field) {
        return <Widget key={field.id} widget={field} resolution={props.resolution} />
      }
    }
    return <th>&nbsp;</th>
  } else if (MC.getFieldParamBooleanValue(props.tableColumn, '@filterByRange') && MC.getFieldParamValue(props.tableColumn, '@filterType') !== 'combobox') {
    return <th key={props.tableColumn.rbsid}><TableFilterInput {...props} valueIndex={0} /><TableFilterInput {...props} valueIndex={1} /></th>
  } else {
    return <th key={props.tableColumn.rbsid}><TableFilterInput {...props} valueIndex={0} /></th>
  }

}

export default TableFilterCell